import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'
import { FeatureEntitlements } from './featureEntitlements'

export const caperAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ConnectedStoresView],
}

export const uposStatusAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.UposViewStatus],
}
export const uposRetailerAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.UposConfigRetailer],
}
export const uposStoreAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.UposConfigStore],
}

export const shelfLabelsAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ShelfLabelsModify],
}

export const unifiedBarcodesAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ConnectedStoresView],
}

export const notOnFileAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.ConnectedStoresView],
  },
]

export const notOnFileRetailerAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.CaperNotOnFileView],
    featureToggles: [FeatureToggle.notOnFile],
    featureEntitlementIds: [FeatureEntitlements.Caper],
  },
  {
    permissions: [Permission.ConnectedStoresView],
  },
]

export const caperTransactionsAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.CaperTransactionsView],
  featureEntitlementIds: [FeatureEntitlements.Caper],
}

export const inventoryIntelligenceAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ConnectedStoresView],
  // permissions: [Permission.InventoryIntelligenceView],
  // featureToggles: [FeatureToggle.inventoryIntelligence],
}

export const paymentTerminalsAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ConnectedStoresView],
}
